var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05185e-08 9C1.05185e-08 8.61765 0.316034 8.30769 0.705882 8.30769H23.2941C23.684 8.30769 24 8.61765 24 9C24 9.38235 23.684 9.69231 23.2941 9.69231H0.705882C0.316034 9.69231 1.05185e-08 9.38235 1.05185e-08 9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6756 0.202772C9.95127 0.473135 9.95127 0.91148 9.6756 1.18184L1.70415 9L9.6756 16.8182C9.95127 17.0885 9.95127 17.5269 9.6756 17.7972C9.39994 18.0676 8.953 18.0676 8.67734 17.7972L0.206748 9.48954C-0.0689161 9.21917 -0.0689161 8.78083 0.206748 8.51046L8.67734 0.202772C8.953 -0.0675908 9.39994 -0.0675908 9.6756 0.202772Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBack);
export default __webpack_public_path__ + "static/media/icn-back.5a1ee99f.svg";
export { ForwardRef as ReactComponent };